export default "__VITE_ASSET__CBtUsDrO__"